module.exports = __webpack_public_path__ + "img/ico-swiper-btn-next.8df073f5.svg";